import { useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router'
import { toast } from 'react-toastify';
import { useAppContext } from '../../../appProvider/contextProvider';
import CustomContentForm from '../../../components/ContentAndAppearance/CustomContentForm';
import NativePromptForm from '../../../components/ContentAndAppearance/NativePromptForm';
import RightStickyForm from '../../../components/ContentAndAppearance/RightStickyForm';
import MessageBox from '../../../components/DesktopPrompts/MessageBox';
import NativePrompt from '../../../components/DesktopPrompts/Native';
import OverlayPrompt from '../../../components/DesktopPrompts/OverlayPrompt';
import PopUp from '../../../components/DesktopPrompts/PopUp';
import RightSticky from '../../../components/DesktopPrompts/RightSticky';
import SlideDown from '../../../components/DesktopPrompts/SlideDown';
import SlideRight from '../../../components/DesktopPrompts/SlideRight';
import StickyHeader from '../../../components/DesktopPrompts/StickyHeader';
import { ERRORS, URL_VALIDATOR } from '../../../constants/AppConstants';
import { getDesktopPrompt, updateDesktopPrompt } from '../../../services/websitesService';


const DesktopPrompt = () => {

    const history = useHistory();

    const { selectedWebsite, 
        setSelectedWebsite, 
        setMenuCollapsed,
        setPathToNavigate,
        setDiscardPromptOpen, 
        isDirty, 
        setIsDirty
    } = useAppContext();

    const [ desktopPromptData, setDesktopPromptData ] = useState(null);

    const [ selectedDesign, setSelectedDesigns ] = useState('Native');

    const [ subscriberType, setSubscriberType ] = useState('');
    const [ subscriptionValue, setSubscriptionValue ] = useState(null);
    const [subscriptionValueError, setSubscriptionValueError] = useState(null);

    const [ openAcc,setOpenAcc ] = useState('design');

    const [ addOverlay, setAddOverlay ] = useState(true);
    const [ overlayMessage, setOverlayMessage ] = useState('')
    const [ overlayError,  ] = useState(null);

    const [ title, setTitle ] = useState('');
    const [ titleColor, setTitleColor ] = useState('#000000');


    const [ message, setMessage ] = useState('');
    const [ messageColor, setMessageColor ] = useState('#999999');


    const [ allowBtnText, setAllowBtnText ] = useState('');
    const [ allowBtnTextColor, setAllowBtnTextColor ] = useState('');
    const [ allowBtnColor, setAllowBtnColor ] = useState('');


    const [ denyBtnText, setDenyBtnText ] = useState('');
    const [ denyBtnTextColor, setDenyBtnTextColor ] = useState('');
    const [ denyBtnColor, setDenyBtnColor ] = useState('');

    const [ background, setBackground ] = useState('');

    const [ stickyText, setStickyText ] = useState('Get Notifications');
    const [ stickyPosition, setStickyPosition] = useState('left');
    const [ stickyBgColor, setStickyBgColor ] = useState('#2C97DE');


    const [icon, setPromptIcon] = useState(null);
    const [iconName, setIconName] = useState(null);
    const [iconPath, setIconPath] = useState(null);
    const [ displayIconPath, setDisplayIconPath ] = useState('');


    const [isDiscarded, setIsDiscarded] = useState(false);
    
    const [titleError, setTitleError] = useState(null); 
    const [messageError, setMessageError] = useState(null); 
    const [allowTextError, setAllowTextError] = useState(null); 
    const [denyTextError, setDenyTextError] = useState(null); 
    
    const [stickyTextError, setStickyTextError] = useState(null)


    useEffect(() => {

        const discard = () => {
            console.log(desktopPromptData);
            setDefaultSelected(desktopPromptData);
        }

        document.addEventListener('discardEvent', discard);
        setMenuCollapsed(true);
        return () => {
            document.removeEventListener('discardEvent', discard);
        }
    }, [desktopPromptData])
    

    useQuery(['fetchDesktopPrompt', selectedWebsite?.id],  () => getDesktopPrompt(selectedWebsite?.id) , {
        enabled: !!selectedWebsite,
        onSuccess: (desktopPromptData) => {
            console.log(desktopPromptData);
            setDesktopPromptData(desktopPromptData);
            setDefaultSelected(desktopPromptData)
        }
    });

    const handelSubscriptionChange = ({target}) => {
        setSubscriptionValue(null);
        setSubscriptionValueError(null);
        setSubscriberType(target.value);
        setIsDirty(true);
    }

    const handelSubscriptionValue = (value) => {
        setIsDirty(true);
        setSubscriptionValue(value);
        if(value.trim().length <= 0 ) {
            setSubscriptionValueError('Value for subscription is required');
        }
        else if(subscriberType ==='SURLS') {
            if(!value.match(URL_VALIDATOR)) {
                setSubscriptionValueError(ERRORS.WEBSITE_URL_VALID);
            } else {
                setSubscriptionValueError(null);
            }
        }
        else if(subscriberType === 'TD') {
            if(value < 10 ) {
                setSubscriptionValueError('Please enter value above 10 seconds');
            } else {
                setSubscriptionValueError(null);
            }
        } else if(subscriberType === 'NOV') {
            if(value < 1 ) {
                setSubscriptionValueError('Please enter value above 0 visit');
            } else {
                setSubscriptionValueError(null);
            }
        }else {
            setSubscriptionValueError(null);
        }

    } 

    

    const setDefaultSelected = (promptData) => {

        setSelectedDesigns(promptData?.type || '');

        setTitle(promptData?.title || '');
        setTitleColor(promptData?.title_color || '');
        
        setMessage(promptData?.message || '');
        setMessageColor(promptData?.message_color || '');

        setAllowBtnText(promptData?.allow_btn_text || '');
        setAllowBtnTextColor(promptData?.allow_btn_color || '');
        setAllowBtnColor(promptData?.allow_btn_bg || '');

        setDenyBtnText(promptData?.deny_btn_text || '');
        setDenyBtnTextColor(promptData?.deny_btn_color || '');
        setDenyBtnColor(promptData?.deny_btn_bg || '');

        setBackground(promptData?.background || '');

        setSubscriberType(promptData?.start_mode || 'OPL');
        if(promptData?.start_mode !== 'OPL') {
            setSubscriptionValue(promptData?.start_mode_value);
        }

        if(promptData?.icon) {
            setIconName('icon.jpg');
            setIconPath(promptData.icon);
            setDisplayIconPath(promptData.icon);
        } else if(!promptData?.icon) {
            setIconName('');
            setIconPath('');
            setDisplayIconPath('');
        }

        if(promptData?.type === 'SB') {
            setStickyText(promptData?.sticky_title);
            setStickyBgColor(promptData?.sticky_background);
            setStickyPosition(promptData?.position);
        }

        setIsDiscarded(true);
        setIsDirty(false);
    }

    const getPromptData = () => {
        const formData = new FormData();
        if(selectedDesign === 'SB') {
            formData.append('sticky_title', stickyText);
            formData.append('sticky_background  ', stickyBgColor);
        } else {
            formData.append('title', title);
            formData.append('title_color', titleColor);
            formData.append('background', background);
        }
        formData.append('message', message);
        formData.append('message_color', messageColor);
        formData.append('allow_btn_text', allowBtnText);
        formData.append('allow_btn_color', allowBtnTextColor);
        formData.append('allow_btn_bg', allowBtnColor);
        formData.append('deny_btn_text', denyBtnText);
        formData.append('deny_btn_color', denyBtnTextColor);
        formData.append('deny_btn_bg', denyBtnColor);
        formData.append('start_mode', subscriberType);
        formData.append('type', selectedDesign);
        formData.append('position', stickyPosition);
        if(icon) {
            formData.append('icon', icon);
        } else if(!icon && !iconPath) {
            formData.append('icon', '');
        }
        if(subscriberType !== 'OPL') {
            formData.append('start_mode_value', subscriptionValue);
        }
    
        return formData;
    
    }

    const discard = () => {
        setDiscardPromptOpen(true);
    }
    
    const onSave = (event) => {
        event.preventDefault();
        const promptData = getPromptData();
        savePrompt.mutate(promptData);
    }

    const savePrompt = useMutation((formData) => {
        return updateDesktopPrompt(selectedWebsite?.id, formData);
    }, {
        onSuccess: (desktopPromptData) => {
            if(desktopPromptData?.errors) {

            } else {
                setDefaultSelected(desktopPromptData);
                selectedWebsite.desktop_prompt = desktopPromptData;
                setSelectedWebsite(selectedWebsite);
                toast.success('Desktop Permission Prompt updated successfully');
                setIsDirty(false);
            }
        }
    });

    const handelAccordion = (accordion) => {
        if(openAcc === accordion) {
            setOpenAcc(null);
        } else {
            setOpenAcc(accordion);
        }
    }

    const setDefaultIcons = () => {
        if(desktopPromptData?.icon) {
            setIconName('icon.jpg');
            setIconPath(desktopPromptData.icon);
            setDisplayIconPath(desktopPromptData?.icon)
        } else {
            setIconName('');
            setIconPath('');
            setDisplayIconPath('');
        }

    }

    const changeDesign = (design) => {
        setIsDirty(true);
        if(selectedDesign ===  'SB') {
            setBackground(desktopPromptData?.background || '');
        }
        setSelectedDesigns(design);
        
    }

    const goBack = () => {
        if(isDirty) {
            setDiscardPromptOpen(true);
            setPathToNavigate('/permission-prompt')
        } else {
            history.push('/permission-prompt');
        }
    }

    const isSaveDisabled = () => {
        return titleError || messageError || denyTextError ||allowTextError || stickyTextError || subscriptionValueError ||
        (subscriberType !== 'OPL' && (!subscriptionValue  ||  (subscriptionValue && subscriptionValue.length <= 0)))
    }

    return <> 
        <div className="panel d-flex-flex-column full-height">
                <div className="panel-header">                     
                    <div className="d-flex justify-content-between align-items-space-between">
                        <div>
                            <h3 className="mb-0"><i className="icon icon-chevron-left mr-2" onClick={() => goBack()} ></i>Desktop</h3>
                        </div>
                        <div className="d-flex justify-content-between" style={{gap: '10px'}}>
                            <button className="btn btn-sm btn-danger" disabled={!isDirty} onClick={discard} >Discard</button>
                            <button className="btn btn-sm btn-primary" disabled={isSaveDisabled()} onClick={onSave}>Save</button>                                         
                        </div> 
                    </div>              
                </div>
                <div className="panel-body p-0 d-flex flex-column full-height scrollable_y">
                    <div className="row no-gutters full-height">
                        <div className="col-12 col-xl-4 d-flex flex-column br-right">
                            <div className="my-2 mx-4">
                                <div className="panel panel-bordered">
                                    <div className="panel-header m-0 p-2" onClick={() => handelAccordion('design')}>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h6 className="mb-0 medium">Design</h6>
                                            <button className="btn btn-neutral"><i 
                                            className={ openAcc === 'design'? 'increment-icon increment-icon-sm default' : 'decrement-icon decrement-icon-sm default'}></i></button>
                                        </div>  
                                    </div>
                                    <div className="panel-body p-2" style={{display: openAcc === 'design' ? 'block' : 'none'}} >
                                        <div className="row no-gutters native-features">
                                            <div className="col-4 mb-2" onClick={() => changeDesign('native')} >
                                                <a className={selectedDesign === 'native' ? 'prompt-container active' : 'prompt-container'}>
                                                    <div className="custom-control custom-checkbox">
                                                        <input 
                                                            type="checkbox" 
                                                            className="custom-control-input"
                                                            id="customCheck1"
                                                            checked={selectedDesign === 'native'}
                                                            onChange={() => changeDesign('native')}
                                                            />
                                                        <label className="custom-control-label" htmlFor="customCheck1"></label>
                                                    </div>
                                                    <div className="title">Default</div>
                                                    <div className="content-box" data-prompt="default">                                                            
                                                        <div className="prompt alert prompt-native-alert"></div>
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="col-4 mb-2" onClick={() => changeDesign('DB')}>
                                                <a className={selectedDesign === 'DB    ' ? 'prompt-container active' : 'prompt-container'}>
                                                    <div className="custom-control custom-checkbox">
                                                        <input 
                                                            type="checkbox"
                                                            className="custom-control-input"
                                                            id="customCheck2"
                                                            checked={selectedDesign === 'DB'}
                                                            onChange={() => changeDesign('DB')}
                                                        />
                                                        <label className="custom-control-label" htmlFor="customCheck2"></label>
                                                    </div>                                                        
                                                    <div className="title">Slide Down</div>
                                                    <div className="content-box" data-prompt="dialog">
                                                        <div className="prompt alert prompt-native-dialog"></div>                                                                                                                        
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="col-4 mb-2" onClick={() => changeDesign('CM')}>
                                                <a className={selectedDesign === 'CM' ? 'prompt-container active' : 'prompt-container'}>
                                                    <div className="custom-control custom-checkbox">
                                                        <input 
                                                            type="checkbox" 
                                                            className="custom-control-input" 
                                                            id="customCheck3" 
                                                            checked={selectedDesign === 'CM'}
                                                            onChange={() => changeDesign('CM')}
                                                        />
                                                        <label className="custom-control-label" htmlFor="customCheck3"></label>
                                                    </div>                                                        
                                                    <div className="title">Popup</div>
                                                    <div className="content-box" data-prompt="popup">                    
                                                        <div className="prompt prompt-center"></div>                                         
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="col-4 mb-2" onClick={() => changeDesign('SUB')}>
                                                <a className={selectedDesign === 'SUB' ? 'prompt-container active' : 'prompt-container'}>
                                                    <div className="custom-control custom-checkbox">
                                                        <input 
                                                            type="checkbox" 
                                                            className="custom-control-input" 
                                                            id="customCheck4"
                                                            checked={selectedDesign === 'SUB'}
                                                            onChange={() => changeDesign('SUB')}
                                                        />
                                                        <label className="custom-control-label" htmlFor="customCheck4"></label>
                                                    </div>                                                        
                                                    <div className="title">Slide Up</div>
                                                    <div className="content-box" data-prompt="message-box">                    
                                                        <div className="prompt"></div>                                         
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="col-4 mb-2" onClick={() => changeDesign('SH')}>
                                                <a className={selectedDesign === 'SH' ? 'prompt-container active' : 'prompt-container'}>
                                                <div className="custom-control custom-checkbox">
                                                        <input 
                                                            type="checkbox" 
                                                            className="custom-control-input" 
                                                            id="customCheck5"
                                                            checked={selectedDesign === 'SH'}
                                                            onChange={() => changeDesign('SH')}
                                                        />
                                                        <label className="custom-control-label" htmlFor="customCheck5"></label>
                                                    </div>                                                      
                                                    <div className="title">Top Sticky</div>
                                                    <div className="content-box" data-prompt="top-sticky">                    
                                                        <div className="prompt"></div>                                         
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="col-4 mb-2" onClick={() => changeDesign('SB')}>
                                                <a className={selectedDesign === 'SB' ? 'prompt-container active' : 'prompt-container'}>
                                                <div className="custom-control custom-checkbox">
                                                        <input 
                                                            type="checkbox"
                                                            className="custom-control-input" 
                                                            id="customCheck6"
                                                            checked={selectedDesign === 'SB'}
                                                            onChange={() => changeDesign('SB')}    
                                                        />
                                                        <label className="custom-control-label" htmlFor="customCheck6"></label>
                                                    </div>                                                        
                                                    <div className="title">Sticky</div>
                                                    <div className="content-box" data-prompt="right-sticky">                    
                                                        <div className="prompt"></div>                                         
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="col-4 mb-2" onClick={() => changeDesign('RS')}>
                                                <a className={selectedDesign === 'RS' ? 'prompt-container active' : 'prompt-container'}>
                                                <div className="custom-control custom-checkbox">
                                                        <input 
                                                            type="checkbox"
                                                            className="custom-control-input"
                                                            id="customCheck8"
                                                            checked={selectedDesign === 'RS'}
                                                            onChange={() => changeDesign('RS')}
                                                        />
                                                        <label className="custom-control-label" htmlFor="customCheck8"></label>
                                                    </div>                                                        
                                                    <div className="title">Side in Right</div>
                                                    <div className="content-box" data-prompt="side-in-right">                    
                                                        <div className="prompt"></div>                                         
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="col-4 mb-2" onClick={() => changeDesign('FS')}>
                                                <a className={selectedDesign === 'FS' ? 'prompt-container active' : 'prompt-container'}>
                                                <div className="custom-control custom-checkbox">
                                                        <input 
                                                            type="checkbox"
                                                            className="custom-control-input" 
                                                            id="customCheck9"
                                                            checked={selectedDesign === 'FS'}
                                                            onChange={() => changeDesign('FS')}
                                                        />
                                                        <label className="custom-control-label" htmlFor="customCheck9"></label>
                                                    </div>                                                        
                                                    <div className="title">Overlay</div>
                                                    <div className="content-box" data-prompt="overlay">                    
                                                        <div className="prompt"></div>                                         
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            { selectedDesign !== 'native' && <div className="my-2 mx-4">
                                    <div className="panel panel-bordered">
                                    <div className="panel-header m-0 p-2" onClick={() => handelAccordion('C&A')}>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h6 className="mb-0 medium">Content &amp; Apperance</h6>
                                            <button className="btn btn-neutral"><i 
                                            className={ openAcc === 'C&A'? 'increment-icon increment-icon-sm default' : 'decrement-icon decrement-icon-sm default'}
                                            ></i></button>
                                        </div>  
                                    </div>
                                    <div className="panel-body p-2" style={{display: openAcc === 'C&A' ? 'block' : 'none'}}>
                                    { 
                                            selectedDesign === 'native' && <NativePromptForm 
                                                addOverlay={addOverlay}
                                                setAddOverlay={setAddOverlay}
                                                overlayMessage={overlayMessage}
                                                setOverlayMessage={setOverlayMessage}
                                                overlayError={overlayError}
                                            />
                                        }
                                        {
                                            (selectedDesign === 'SB' && selectedDesign !== 'native') && <RightStickyForm 
                                                stickyText={stickyText}
                                                setStickyText={setStickyText}
                                                stickyPosition={stickyPosition}
                                                setStickyPosition={setStickyPosition}
                                                stickyBgColor={stickyBgColor}
                                                setStickyBgColor={setStickyBgColor}
                                                isDiscarded = {isDiscarded}
                                                setIsDiscarded = {setIsDiscarded}
                                                setIsDirty={setIsDirty}

                                                stickyTextError={stickyTextError}
                                                setStickyTextError={setStickyTextError}
                                            />
                                        }
                                        {
                                            selectedDesign !== 'native' && selectedDesign !== 'SB' &&  <CustomContentForm 
                                            title={title}
                                            setTitle={setTitle}
                                            titleColor={titleColor}
                                            setTitleColor={setTitleColor}
                                            selectedDesign={selectedDesign}

                                            message={message}
                                            setMessage={setMessage}
                                            messageColor={messageColor}
                                            setMessageColor={setMessageColor}
                                            
                                            allowBtnTex={allowBtnText}
                                            setAllowBtnText={setAllowBtnText}
                                            allowBtnTextColor={allowBtnTextColor}
                                            setAllowBtnTextColor={setAllowBtnTextColor}
                                            allowBtnColor={allowBtnColor}
                                            setAllowBtnColor={setAllowBtnColor}

                                            denyBtnText={denyBtnText}
                                            setDenyBtnText={setDenyBtnText}
                                            denyBtnTextColor={denyBtnTextColor}
                                            setDenyBtnTextColor={setDenyBtnTextColor}
                                            denyBtnColor={denyBtnColor}
                                            setDenyBtnColor={setDenyBtnColor}
                                            
                                            background={background}
                                            setBackground={setBackground}
                                            
                                            iconPath={iconPath}
                                            iconName={iconName}
                                            setIconPath={setIconPath}
                                            setIconName={setIconName}
                                            setPromptIcon={setPromptIcon}

                                            isDiscarded = {isDiscarded}
                                            setIsDiscarded = {setIsDiscarded}

                                            setDefaultIcons={setDefaultIcons}
                                            setIsDirty={setIsDirty}

                                            titleError={titleError}
                                            messageError={messageError}
                                            allowTextError={allowTextError}
                                            denyTextError={denyTextError}

                                            setTitleError={setTitleError}
                                            setMessageError={setMessageError}
                                            setAllowTextError={setAllowTextError}
                                            setDenyTextError={setDenyTextError}

                                            setDisplayIconPath={setDisplayIconPath}
                                            displayIconPath={displayIconPath}
                                        />
                                        }
                                        
                                    </div>
                                </div>
                                </div>
                            }
                            <div className="my-2 mx-4">
                                <div className="panel panel-bordered">
                                    <div className="panel-header m-0 p-2" onClick={() => handelAccordion('ATS')} >
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h6 className="mb-0 medium">Trigger the Permission Prompt on</h6>
                                            <button className="btn btn-neutral"><i 
                                                className={ openAcc === 'ATS'? 'increment-icon increment-icon-sm default' : 'decrement-icon decrement-icon-sm default'}
                                            ></i></button>
                                        </div>  
                                    </div>
                                    <div className="panel-body p-2" style={{display: openAcc === 'ATS' ? 'block' : 'none'}}>
                                        <div className="custom-control custom-radio">
                                            <input
                                                type="radio"
                                                id="customRadio1"
                                                name="customRadio"
                                                className="custom-control-input"
                                                value='OPL'
                                                checked={subscriberType === 'OPL' }
                                                onChange={handelSubscriptionChange}
                                            />
                                            <label className="custom-control-label" htmlFor="customRadio1">On Page Load</label>
                                        </div>
                                        {/* <div className="form-group">  
                                            <textarea type="text" rows="3" className="form-control"></textarea>
                                        </div> */}
                                        <div className="d-flex flex-column justify-content-between align-items-start mb-1">
                                            <div className="custom-control custom-radio">
                                                <input 
                                                    type="radio" 
                                                    id="customRadio3" 
                                                    name="customRadio3" 
                                                    className="custom-control-input"
                                                    value='TD'
                                                    checked={subscriberType === 'TD' }                                            
                                                    onChange={handelSubscriptionChange}    
                                                />
                                                <label className="custom-control-label" htmlFor="customRadio3">On Time Delay</label>
                                            </div>
                                            {subscriberType === 'TD' && <><div className="d-flex align-items-center mt-">
                                                <div className="d-flex mx-3">
                                                    <input 
                                                        type="number" 
                                                        id="customRadio4" 
                                                        name="customRadio4" 
                                                        className="form-control"
                                                        value={subscriberType !== 'TD' ? '' : subscriptionValue}                                      
                                                        onChange={({target}) => handelSubscriptionValue(target.value) }
                                                        disabled={subscriberType !== 'TD'}    
                                                    />
                                                    
                                                </div>
                                                <p>Second(s)</p>
                                            </div>
                                            {subscriptionValueError && <span className="error-message">{subscriptionValueError}</span>}
                                            </>}
                                        </div>
                                        <div className="d-flex flex-column justify-content-between align-items-start mb-1">
                                            <div className="custom-control custom-radio ">
                                                <input 
                                                    type="radio" 
                                                    id="customRadio5" 
                                                    name="customRadio5" 
                                                    className="custom-control-input"  
                                                    value='NOV'                           
                                                    checked={subscriberType === 'NOV' }                 
                                                    onChange={handelSubscriptionChange}  
                                                />
                                                <label className="custom-control-label" htmlFor="customRadio5">After Number of Visits</label>
                                            </div>
                                            {subscriberType === 'NOV' && <><div className="d-flex align-items-center mt-2"> 
                                                <div className="d-flex mx-3">
                                                <input 
                                                        type="number" 
                                                        id="customRadio3" 
                                                        name="customRadio" 
                                                        className="form-control"
                                                        value={subscriberType !== 'NOV' ? '' : subscriptionValue}                                
                                                        onChange={({target}) => handelSubscriptionValue(target.value) }
                                                        disabled={subscriberType !== 'NOV'}    
                                                        min="0"
                                                    />
                                                </div>
                                            </div>
                                            {subscriptionValueError && <span className="error-message">{subscriptionValueError}</span>}
                                            </>}
                                        </div>
                                        <div className="d-flex flex-column justify-content-between align-items-start mb-1">
                                            <div className="custom-control custom-radio">
                                                <input 
                                                    type="radio" 
                                                    id="customUrl" 
                                                    name="customUrl" 
                                                    className="custom-control-input"
                                                    value="SURLS"
                                                    checked={subscriberType === 'SURLS' }
                                                    onChange={handelSubscriptionChange}    
                                                />
                                                <label className="custom-control-label" htmlFor="customUrl">On Specific Url</label>
                                            </div>
                                           { subscriberType === 'SURLS' && <><div className="d-flex align-items-center mt-2">
                                                <div className="d-flex mx-3">
                                                    <input 
                                                        type="text" 
                                                        id="customUrl2" 
                                                        name="customUrl2" 
                                                        className="form-control"
                                                        value={subscriberType !== 'SURLS' ? '' : subscriptionValue}                                            
                                                        onChange={({target}) => handelSubscriptionValue(target.value) }
                                                        disabled={subscriberType !== 'SURLS'}
                                                        placeholder='https://chirpyweb.com'
                                                    />
                                                </div>
                                            </div>
                                            {subscriptionValueError && <span className="error-message">{subscriptionValueError}</span>}
                                            </>
                                            }
                                        </div>
                                        <div className="d-flex flex-column justify-content-between align-items-start mb-1">
                                            <div className="custom-control custom-radio">
                                                <input 
                                                    type="radio" 
                                                    id="customRadio2" 
                                                    name="customRadio" 
                                                    className="custom-control-input"
                                                    value="MJSC"
                                                    checked={subscriberType === 'MJSC' }
                                                    onChange={handelSubscriptionChange}    
                                                />
                                                <label className="custom-control-label" htmlFor="customRadio2">Manual Javascript</label>
                                            </div>
                                           { subscriberType === 'MJSC' && <><div className="d-flex align-items-center mt-2">
                                                <div className="d-flex mx-3">
                                                    <input 
                                                        type="text" 
                                                        id="customRadio2" 
                                                        name="customRadio" 
                                                        className="form-control"
                                                        value={subscriberType !== 'MJSC' ? '' : subscriptionValue}                                            
                                                        onChange={({target}) => handelSubscriptionValue(target.value) }
                                                        disabled={subscriberType !== 'MJSC'}
                                                        placeholder='id of HTML element'
                                                    />
                                                </div>
                                            </div>
                                            {subscriptionValueError && <span className="error-message">{subscriptionValueError}</span>}
                                            </>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-xl-8 d-none d-lg-block full-height">
                            <div className="d-flex flex-column p-4 full-height">
                                <h5 className="px-3 mb-0">Preview</h5>
                                <div className="panel panel-bordered full-height m-2">
                                    <div className="panel-header m-0 bg-light-grey">
                                        <div className="indicators d-flex">
                                            <div className="red"></div>
                                            <div className="grey"></div>
                                            <div className="green"></div>
                                        </div>
                                    </div>
                                    <div className="panel-body p-0 full-height">
                                        <div className="preview-container bg-grey full-height" style={{background: addOverlay ? 'rgba(0,0,0,0.3)' : 'white'}}>
                                            {/* <!-- change the value dynamically of this attr data-prompt-position="top" to top,bottom and center --> */}
                                            {
                                                selectedDesign === 'native' && <><NativePrompt /> 
                                                    {addOverlay && <p className="text-white">{overlayMessage}</p>}
                                                </>
                                            }
                                            {
                                                selectedDesign === 'DB' && <SlideDown
                                                    title={title}
                                                    titleColor={titleColor}
                                                    message={message}
                                                    messageColor={messageColor}
                                                    allowBtnText={allowBtnText}
                                                    allowBtnTextColor={allowBtnTextColor}
                                                    allowBtnColor={allowBtnColor}
                                                    denyBtnText={denyBtnText}
                                                    denyBtnTextColor={denyBtnTextColor}
                                                    denyBtnColor={denyBtnColor}
                                                    background={background} 
                                                    iconPath={displayIconPath || selectedWebsite?.logo}
                                                /> 
                                            }
                                            {
                                                selectedDesign === 'CM' && <PopUp
                                                    title={title}
                                                    titleColor={titleColor}
                                                    message={message}
                                                    messageColor={messageColor}
                                                    allowBtnText={allowBtnText}
                                                    allowBtnTextColor={allowBtnTextColor}
                                                    allowBtnColor={allowBtnColor}
                                                    denyBtnText={denyBtnText}
                                                    denyBtnTextColor={denyBtnTextColor}
                                                    denyBtnColor={denyBtnColor}
                                                    background={background}
                                                />
                                            }
                                            {
                                                selectedDesign === 'SB' && <RightSticky 
                                                    stickyText={stickyText}
                                                    stickyPosition={stickyPosition}
                                                    stickyBgColor={stickyBgColor}
                                                />
                                            }
                                            {
                                                selectedDesign === 'SH' && <StickyHeader 
                                                    title={title}
                                                    titleColor={titleColor}
                                                    message={message}
                                                    messageColor={messageColor}
                                                    allowBtnText={allowBtnText}
                                                    allowBtnTextColor={allowBtnTextColor}
                                                    allowBtnColor={allowBtnColor}
                                                    denyBtnText={denyBtnText}
                                                    denyBtnTextColor={denyBtnTextColor}
                                                    denyBtnColor={denyBtnColor}
                                                    background={background}
                                                    iconPath={displayIconPath || selectedWebsite?.logo}
                                                />
                                            }
                                            {
                                                selectedDesign === 'SUB' && <MessageBox 
                                                    title={title}
                                                    titleColor={titleColor}
                                                    message={message}
                                                    messageColor={messageColor}
                                                    allowBtnText={allowBtnText}
                                                    allowBtnTextColor={allowBtnTextColor}
                                                    allowBtnColor={allowBtnColor}
                                                    denyBtnText={denyBtnText}
                                                    denyBtnTextColor={denyBtnTextColor}
                                                    denyBtnColor={denyBtnColor}
                                                    background={background}
                                                    iconPath={displayIconPath || selectedWebsite?.logo}
                                                /> 
                                            }
                                            {
                                                selectedDesign === 'RS' && <SlideRight 
                                                    title={title}
                                                    titleColor={titleColor}
                                                    message={message}
                                                    messageColor={messageColor}
                                                    allowBtnText={allowBtnText}
                                                    allowBtnTextColor={allowBtnTextColor}
                                                    allowBtnColor={allowBtnColor}
                                                    denyBtnText={denyBtnText}
                                                    denyBtnTextColor={denyBtnTextColor}
                                                    denyBtnColor={denyBtnColor}
                                                    background={background}
                                                    iconPath={displayIconPath || selectedWebsite?.logo}
                                                />
                                            }
                                            {
                                                selectedDesign === 'FS' &&  <OverlayPrompt
                                                    title={title}
                                                    titleColor={titleColor}
                                                    message={message}
                                                    messageColor={messageColor}
                                                    allowBtnText={allowBtnText}
                                                    allowBtnTextColor={allowBtnTextColor}
                                                    allowBtnColor={allowBtnColor}
                                                    denyBtnText={denyBtnText}
                                                    denyBtnTextColor={denyBtnTextColor}
                                                    denyBtnColor={denyBtnColor}
                                                    background={background}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>                                    
                        </div>
                    </div>
                </div>
            </div>
 
    </>
}


export default DesktopPrompt